import { SelectionMode, Selection } from '@fluentui/react';

function reducer(state, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_SELECTED_ITEMS':
      return {
        ...state,
        selectedItems: payload,
        isAllSelected: payload.length === (state.items && state.items.length),
        hasItemSelected: payload.length > 0,
      };
    case 'SET_ALL_SELECTED':
      state.selection.setAllSelected(payload);
      return {
        ...state,
        isAllSelected: payload,
        hasItemSelected: payload,
      };
    case 'SET_CROSS_PAGE_ALL_SELECTED':
    {
      if (payload) {
        state.selection.setAllSelected(true);
      }
      return {
        ...state,
        isCrossPageAllSelected: payload,
      };
    }
    case 'SET_SELECTION_MODE':
    {
      state.selection.setAllSelected(false);
      return {
        ...state,
        selectedItems: [],
        isAllSelected: false,
        hasItemSelected: false,
        selectionMode: payload,
      };
    }
    case 'TABLE_DID_UPDATE':
      if (payload.items !== state.items && state.isCrossPageAllSelected) {
        state.selection.setAllSelected(true);
      }
      return state;
    case 'SET_SELECTION':
      state.selection.setChangeEvents(false);
      payload.forEach((item) => {
        state.selection.setKeySelected(item.key, true, false);
      });
      state.selection.setChangeEvents(true);
      return state;
    case 'SET_SELECTED_ITEMS_IN_ALL_PAGES':
      return {
        ...state,
        selectedItemsInAllPages: payload,
      };
    default:
      return state;
  }
}

const getInitialState = ({ selectionMode, initSelectedItems }) => {
  const state = {
    selectionMode: selectionMode || SelectionMode.none,
    hasItemSelected: false,
    isAllSelected: false,
    isCrossPageAllSelected: false,
    selection: new Selection(),
    selectedItemsInAllPages: initSelectedItems || [],
  };
  return state;
};

export default {
  reducer,
  getInitialState,
};
